import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import Provider from "./provider";
import Breadcrumb from "../../../component/breadcrumb";
import { withTranslation } from "react-i18next";
class ProviderProfile extends Component {
  state = {
    bread: [{ title: this.props.t("MY_PROFILE"), url: "/profile" }],
  };
  componentDidMount() {
    this.props.setErrorMessage();
  }
  render() {
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
            </Grid>
          </div>
        </div>
        <main>
          <Grid container spacing={2}>
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <Provider />
            </Grid>
          </Grid>
        </main>
      </div>
    );
  }
}

// Fetch data from redux store
const mapStateToProps = (state) => {
  return {
    loggedInUserType: state.auth.userLoginType,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(ProviderProfile));
